import { Text, TextProps } from "@flat-ui";
import { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  /** Optional style props to pass to the component */
  sx?: TextProps["sx"];
}

/** Common component to display the subtitle of a page */
export function PageSubtitle({ children, sx }: Props): JSX.Element {
  return (
    <Text
      variant="bodyM"
      component="p"
      sx={{
        marginTop: "10px",
        // `bodyM` reads `text.primary`; the subtitle is deliberately a step lighter than the title.
        color: "text.secondary",
        textAlign: "center",
        ...sx,
      }}
    >
      {children}
    </Text>
  );
}
